const dev = {
  // API_ENDPOINT_URL: 'https://price-api-test.tomei.com.my/v1.0',
  COMMON_API_ENDPOINT_URL: process.env.REACT_COMMON_API_URL,
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL,
  SSO_PORTAL_URL: process.env.REACT_APP_SSO_PORTAL_URL,
  WS_URL: process.env.REACT_APP_WS_URL,
  WS_API_KEY: process.env.REACT_APP_WS_API_KEY,
  PRICE_FEED_WS_URL: process.env.REACT_APP_PRICE_FEED_WS_URL,
  PRICE_FEED_API_KEY: process.env.REACT_APP_PRICE_FEED_API_KEY,
  SSO_API_URL: process.env.REACT_APP_SSO_API_URL,
  APP_BASE_URL: process.env.REACT_APP_APP_BASE_URL,
};

const prod = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL,
  SSO_PORTAL_URL: process.env.REACT_APP_SSO_PORTAL_URL,
  WS_URL: process.env.REACT_APP_WS_URL,
  WS_API_KEY: process.env.REACT_APP_WS_API_KEY,
  PRICE_FEED_WS_URL: process.env.REACT_APP_PRICE_FEED_WS_URL,
  PRICE_FEED_API_KEY: process.env.REACT_APP_PRICE_FEED_API_KEY,
  SSO_API_URL: process.env.REACT_APP_SSO_API_URL,
  APP_BASE_URL: process.env.REACT_APP_APP_BASE_URL,
  COMMON_API_ENDPOINT_URL: process.env.REACT_COMMON_API_URL,
};

const test = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL,
  SSO_PORTAL_URL: process.env.REACT_APP_SSO_PORTAL_URL,
  WS_URL: process.env.REACT_APP_WS_URL,
  WS_API_KEY: process.env.REACT_APP_WS_API_KEY,
  PRICE_FEED_WS_URL: process.env.REACT_APP_PRICE_FEED_WS_URL,
  PRICE_FEED_API_KEY: process.env.REACT_APP_PRICE_FEED_API_KEY,
  SSO_API_URL: process.env.REACT_APP_SSO_API_URL,
  APP_BASE_URL: process.env.REACT_APP_APP_BASE_URL,
  COMMON_API_ENDPOINT_URL: process.env.REACT_COMMON_API_URL,
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev;
    case 'production':
      return prod;
    case 'test':
      return test;
    default:
      break;
  }
};

export const env = getEnv();
